import $ = require('jquery');
import l10n = require('diy/util/l10n');
import Modul from '../../../Modul';
import ModulMatrix from '../../../ModulMatrix';

import ModuleDragSource = require('./ModuleDragSource');
import MatrixDropZone = require('./MatrixDropZone');
import DropZone = require('../../../../common/js/dd/DropZone');
import NavDropZone = require('./NavDropZone');

/* tslint:disable */
declare global {
    interface Window {
        matrixModuleAvoidDragWhileModuleOpen: boolean;
    }
}
/* tslint:enable */

/**
 * Drag source for existing modules (placed in matrix)
 *
 * @depends Modul.js
 * @depends Matrix.js
 */
    class ExistingModuleDragSource extends ModuleDragSource {
        /**
         * Drag mode
         *
         * move (normal mode) or duplicate (when CTRL key is pressed)
         */
        protected dragMode: string = null;

        /**
         * CSS cursor to use for duplicate drag
         * Force the same move cursor on IE<9 because it doesn't support CSS3
         */
        protected duplicateCursor = $.browser.msie && parseInt($.browser.version, 10) < 9 ? 'move' : 'copy';
        /**
         * CSS cursor to use for normal (move) drag
         */
        protected moveCursor = 'move';

        protected orderNo: number;
        protected matrixChildId: number;
        moduleId: number;

        constructor(element: JQuery) {
            super(element);

            this.setModelData();
        }

        init() {
            super.init();

            this.setDraggableOptions({
                // For touch devices we position the element with CSS3, because the
                // content changes while dragging and we can't use a fixed offset
                cursorAt: diy.editor.uiPreference.isPointerModeTouch() ? { top: 0, left: 0} : {top: -15, left: -15},
                cancel: ['.not-sorting-handle', 'input[type=text]', 'textarea', '.iframe',
                    '.single-event-scroller', '.twtr-timeline'].join(", ")
            });
        }

        getDataSourceEl() {
            const moduleId = $(this.element).closest('[data-moduleId]').attr('data-moduleId');

            //do not use the mm[moduleId] here;
            // it is not initialised yet when updating
            return $('#modul_' + moduleId);
        }

        setModelData() {
            super.setModelData();
            const dataSourceEl = this.getDataSourceEl();
            this.matrixId = parseInt(dataSourceEl.attr('data-matrixId'), 10);
            this.orderNo = parseInt(dataSourceEl.attr('data-orderNo'), 10);
            this.matrixChildId = parseInt(dataSourceEl.attr('data-matrixChildId'), 10);
            this.moduleId = parseInt(dataSourceEl.attr('data-moduleId'), 10);
        }

        getLabel() {
            return Modul.getInstance(this.moduleId).textLabel;
        }

        onDragStart(e: MouseEvent, ui: {}): boolean|void {
            const module = Modul.getInstance(this.moduleId);

            //Can't drag when in edit mode
            if (module.getIsInEditMode()) {
                module.showModuleTooltip();
                return false;
            }

            if (!module.supportsMove()) {
                return false;
            }

            /*
             TODO this is an extreme measure taken against the possibility
             of a small bug becoming a big one. We make sure that matrixes
             cannot be dragged by accident while a small element is opened
             inside of them
             However, in case this provokes bad results, adding
             window.matrixModuleAvoidDragWhileModuleOpen = true;
             in the user scripts section will fix this
             */
            if (!window.matrixModuleAvoidDragWhileModuleOpen) {
                try {
                    if (module instanceof ModulMatrix && module.getChildModuleInEditMode() !== null) {
                        module.showModuleTooltip();
                        return false;
                    }
                } catch (e) {
                    // do nothing
                }
            }

            this.dragMode = e.ctrlKey && module.supportsDuplication() ? 'duplicate' : 'move';
            this.allowedCursor = this.dragMode === 'duplicate' ? this.duplicateCursor : this.moveCursor;

            if (this.dragMode === 'move') {
                module.hide();
            }

            super.onDragStart(e, ui);
        }
        getErrorMessage(error: string, dropZone: DropZone) {
            if (dropZone instanceof NavDropZone) {
                switch (error) {
                    case 'module_singleton_in_page': //nobreak
                    case 'module_singleton_in_other_pages':
                        return l10n.getString('module.warningSingleton');
                    case 'same_page':
                        if (this.dragMode === 'duplicate') {
                            return l10n.getString('moduleSelector.restrictedCopySamePageToolTip');
                        } else {
                            return l10n.getString('moduleSelector.restrictedDropSamePageToolTip');
                        }
                    case 'module_too_wide':
                        return l10n.getString('module.addToPageWarningTooWide');
                    default:
                        return '';
                }
            }
            return super.getErrorMessage(error, dropZone);
        }

        canBeDropped(dropZone: MatrixDropZone) {
            if (!dropZone) {
                return false;
            }
            const currentPageId = parseInt($("body").attr("data-pageid"), 10);
            if (dropZone instanceof NavDropZone && dropZone.getPageId() === currentPageId) {
                return this.getErrorMessage('same_page', dropZone);
            }
            return super.canBeDropped(dropZone);
        }

        doDrop(dropZone: MatrixDropZone) {
            const module = Modul.getInstance(this.moduleId);
            const dropParams = dropZone.getDestinationParams();

            switch (this.dragMode) {
                case 'duplicate':
                    module.duplicate(dropParams);
                    break;

                case 'move':
                    // make sure that the drop is in a different position
                    if (module.isPositionChanged(dropParams)) {
                        module.move(dropParams);
                    } else {
                        this.cancelDrop(dropZone);
                    }
                    break;
                default:
                    $.error('Invalid drag mode ' + this.dragMode);
                    break;
            }
        }

        cancelDrop(dropZone: DropZone) {
            //show the module, because we just canceled the drop
            const module = Modul.getInstance(this.moduleId);
            module.show();
            module.scrollToActiveView();
        }
    }

export = ExistingModuleDragSource;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/common/js/dd/ExistingModuleDragSource.ts
 **/